import { globalState } from '../models';

/** 埋点方法 */
export const tracker = (evt: string, ext?: Record<string, any> | string) => {
    globalState.tracker(evt, ext);
};
